import { isAuthenticated, hasAccess } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'
import Store from '@/store'

export default [
  {
    name: 'residential-templates',
    path: '/residential-templates',
    component: () =>
      LazyLoadView(
        import(/* webpackChunkName: "residential-templates" */ '@/views/ResidentialTemplate/ResidentialTemplates.vue'),
      ),
    beforeEnter: hasAccess('residentialTemplates', 'residentialTemplateLeads'),
  },
  {
    name: 'residential-template-create',
    path: '/residential-templates/create/:step?',
    component: () =>
      LazyLoadView(
        import(
          /* webpackChunkName: "residential-template-mutate" */ '@/views/ResidentialTemplate/Mutate/Component.vue'
        ),
      ),
    props: true,
    beforeEnter: hasAccess('residentialTemplates'),
  },
  {
    name: 'residential-template-edit',
    path: '/residentials-template/:id/edit/:step?',
    props: true,
    component: () =>
      LazyLoadView(
        import(
          /* webpackChunkName: "residential-template-mutate" */ '@/views/ResidentialTemplate/Mutate/Component.vue'
        ),
      ),
    beforeEnter: hasAccess('residentialTemplates'),
  },
  {
    name: 'residential-template-dashboard',
    path: '/residential-templates/:id',
    beforeEnter: (to, from, next) => {
      return isAuthenticated(to, from, () => {
        if (Store.getters.hasAccess('residentialTemplates'))
          return next({ name: 'residential-template-edit', params: { id: to.params.id } })
        return next({ name: 'residential-template-leads', params: { reference: to.params.id } })
      })
    },
  },
  {
    name: 'residential-template-leads',
    path: '/residential-templates/:reference/leads',
    props: route => ({ reference: route.params.reference, onModel: 'ResidentialTemplate' }),
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "project-leads" */ '@/views/Project/Leads/Component.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'residential-template-lead-create',
    path: '/residential-templates/:reference/lead/create',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "lead-create" */ '@/views/Lead/Create.vue')),
    beforeEnter: isAuthenticated,
    meta: {
      onModel: 'ResidentialTemplate',
    },
  },
  {
    path: '/residential-templates/:reference/lead/:id/edit',
    redirect: '/residential-templates/:reference/lead/:id',
  },
  {
    name: 'residential-template-lead',
    path: '/residential-templates/:reference/lead/:id',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "lead-dashboard" */ '@/views/Lead/Dashboard.vue')),
    beforeEnter: isAuthenticated,
  },
]
